import React, { ReactNode } from 'react';

type Props = {
  delay?: number;
  children: ReactNode;
};
type State = {
  pastDelay: boolean;
};
export class RenderWithDelay extends React.PureComponent<Props, State> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    delay: 300,
  };

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    pastDelay: false,
  };

  // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'TimeoutID'.
  timeout: TimeoutID | null | undefined;

  componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.delay === 0) {
      this.setState({
        pastDelay: true,
      });
      return;
    }

    this.timeout = setTimeout(
      () => {
        this.setState({
          pastDelay: true,
        });
      }, // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.delay
    );
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  render() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.pastDelay) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment,react/jsx-no-useless-fragment
      return <>{this.props.children}</>;
    }

    return null;
  }
}
